import { createStore } from "vuex-smart-module";
import { root } from "@/store/modules/root";

export default createStore(root);
